// @ts-nocheck
/* eslint-disable */
export const temperaturesIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#F8B1A2" d="M15.667 13.4V4.667a3.667 3.667 0 0 0-7.334 0V13.4a5.5 5.5 0 1 0 7.333 0M12 21.168a3.667 3.667 0 0 1-2.444-6.4l.61-.547V4.667a1.833 1.833 0 1 1 3.667 0v9.553l.611.547a3.667 3.667 0 0 1-2.444 6.4"/><path fill="#F8B1A2" d="M11.084 8.333h1.833v11h-1.833z"/><path fill="#F8B1A2" d="M12 20.25a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5"/></svg>`,
    name: 'temperatures' as const
};